import React from 'react';
import { CheckCircle2Icon, TrendingUpIcon, ShieldCheckIcon, CarIcon, HomeIcon, CreditCardIcon, XCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-20 px-4" data-id="element-205">
      <div className="max-w-5xl mx-auto" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-navy mb-6" data-id="element-208">
            Presentamos <span className="text-green" data-id="element-209">Crédito USA 700+</span>
          </h2>
          <p className="text-xl text-text-muted max-w-3xl mx-auto" data-id="element-210">
            La guía definitiva que te enseña exactamente cómo comenzar desde
            cero, qué hacer en tus primeros 90 días y cómo convertirte en un
            perfil altamente atractivo para los bancos.
          </p>
        </div>

        {/* Transformation: Before vs After */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-211">
          <div className="bg-gray-light p-8 rounded-2xl border border-gray-200" data-id="element-212">
            <h3 className="text-xl font-bold text-text-muted mb-6 flex items-center" data-id="element-213">
              <span className="bg-gray-200 text-gray-600 w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-214">
                ✗
              </span>
              Tu situación antes
            </h3>
            <ul className="space-y-4 text-text-muted" data-id="element-215">
              <li className="flex items-center" data-id="element-216">
                <span className="mr-2 opacity-50" data-id="element-217">•</span> Sin historial de
                crédito.
              </li>
              <li className="flex items-center" data-id="element-218">
                <span className="mr-2 opacity-50" data-id="element-219">•</span> Rechazado por bancos.
              </li>
              <li className="flex items-center" data-id="element-220">
                <span className="mr-2 opacity-50" data-id="element-221">•</span> Confundido sobre el
                sistema.
              </li>
              <li className="flex items-center" data-id="element-222">
                <span className="mr-2 opacity-50" data-id="element-223">•</span> Pagando altos
                intereses.
              </li>
              <li className="flex items-center" data-id="element-224">
                <span className="mr-2 opacity-50" data-id="element-225">•</span> Sin acceso a
                oportunidades.
              </li>
            </ul>
          </div>

          <div className="bg-green-light p-8 rounded-2xl border border-green-200 shadow-lg transform md:-translate-y-2" data-id="element-226">
            <h3 className="text-xl font-bold text-green-hover mb-6 flex items-center" data-id="element-227">
              <span className="bg-green text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-228">
                ✓
              </span>
              Tu situación después
            </h3>
            <ul className="space-y-4 text-navy font-medium" data-id="element-229">
              <li className="flex items-center" data-id="element-230">
                <span className="text-green mr-2" data-id="element-231">✓</span> Historial crediticio
                sólido.
              </li>
              <li className="flex items-center" data-id="element-232">
                <span className="text-green mr-2" data-id="element-233">✓</span> Score acercándose a
                700+.
              </li>
              <li className="flex items-center" data-id="element-234">
                <span className="text-green mr-2" data-id="element-235">✓</span> Mayor confianza
                financiera.
              </li>
              <li className="flex items-center" data-id="element-236">
                <span className="text-green mr-2" data-id="element-237">✓</span> Altas probabilidades
                de aprobación.
              </li>
              <li className="flex items-center" data-id="element-238">
                <span className="text-green mr-2" data-id="element-239">✓</span> Acceso a mejores
                tarjetas y préstamos.
              </li>
            </ul>
          </div>
        </div>

        {/* Visual Benefits */}
        <h3 className="text-2xl font-bold text-center text-navy mb-10" data-id="element-240">
          Lo que lograrás con este método:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-242">
            <ShieldCheckIcon className="w-10 h-10 text-green mb-4" data-id="element-243" />
            <p className="font-bold text-navy" data-id="element-244">
              Entender el sistema crediticio americano
            </p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-245">
            <TrendingUpIcon className="w-10 h-10 text-green mb-4" data-id="element-246" />
            <p className="font-bold text-navy" data-id="element-247">
              Construir historial desde cero
            </p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-248">
            <CheckCircle2Icon className="w-10 h-10 text-green mb-4" data-id="element-249" />
            <p className="font-bold text-navy" data-id="element-250">Mejorar hábitos financieros</p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-251">
            <XCircleIcon className="w-10 h-10 text-green mb-4" data-id="element-252" />
            <p className="font-bold text-navy" data-id="element-253">Evitar errores costosos</p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-254">
            <CreditCardIcon className="w-10 h-10 text-green mb-4" data-id="element-255" />
            <p className="font-bold text-navy" data-id="element-256">Acercarte a un score de 700+</p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-gray-light rounded-xl" data-id="element-257">
            <div className="flex gap-2 mb-4" data-id="element-258">
              <CarIcon className="w-10 h-10 text-green" data-id="element-259" />
              <HomeIcon className="w-10 h-10 text-green" data-id="element-260" />
            </div>
            <p className="font-bold text-navy" data-id="element-261">
              Prepararte para comprar auto o casa
            </p>
          </div>
        </div>
      </div>
    </section>;
}